<div class="container-info light animated fadeIn">
    <div class="head d-flex flex-row justify-content-between">
        <p>Contrato de domiciliación<i class="mnf-question my-auto ms-2 fs-14"></i></p>
     </div>

    <div class="content">
       <p class="fs-18 cl-black fw-bold text-center mt-3">FORMATO DE AUTORIZACIÓN DE CARGO A CUENTA</p>
       <p class="contract" [innerHtml]="contractTemplate"></p>

       
    <div class="d-flex align-items-center justify-content-evenly mb-4 mt-4">
        <button mat-button class="cancel" (click)="next()">Aceptar</button>
    </div>

    </div>

 </div>
 